import { Stop } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'

import { ListItemButton } from 'components/List'
import { EndTestItemProps } from './types'

export const EndTestItem = ({ setDialogOpen }: EndTestItemProps): JSX.Element => {
  const { t } = useTranslation('features/abTests', { keyPrefix: 'endTest' })

  return (
    <ListItemButton
      data-cy='actions-end-test'
      icon={<Stop data-cy='stop-icon' />}
      onClick={(): void => setDialogOpen(true)}
      text={t('label')}
    />
  )
}
